// extracted by mini-css-extract-plugin
export default {"sloganContainer":"SloganBanner_sloganContainer__yIoyn"};